import { styled } from "styled-components";

const Container = styled.div`
  display: flex;
  padding: 0.375rem 0.75rem;
  align-items: center;
  gap: 0.25rem;

  border-radius: 0.625rem;
  background: rgba(249, 243, 242, 0.6);

  color: ${({ theme }) => theme.colors.secondaryText};

  text-align: center;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 140%;
  width: fit-content;
  align-self: center;

  & > svg {
    width: 1.25rem;
    height: 1.25rem;
  }
`;

export default {
  Container,
};
